import { render, staticRenderFns } from "./cbrAccLocationChoose.vue?vue&type=template&id=256f2b04&lang=pug"
import script from "./cbrAccLocationChoose.vue?vue&type=script&lang=js"
export * from "./cbrAccLocationChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports